/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { AccountsService } from './services/AccountsService';
import { AttachmentsService } from './services/AttachmentsService';
import { AuthService } from './services/AuthService';
import { BarcodesService } from './services/BarcodesService';
import { CustomFieldsService } from './services/CustomFieldsService';
import { DocsService } from './services/DocsService';
import { IconsService } from './services/IconsService';
import { ImagesService } from './services/ImagesService';
import { ImportService } from './services/ImportService';
import { ItemsService } from './services/ItemsService';
import { SchemasService } from './services/SchemasService';
import { SentryService } from './services/SentryService';
import { ServeService } from './services/ServeService';
import { SettingsService } from './services/SettingsService';
import { StatusService } from './services/StatusService';
import { UserService } from './services/UserService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class AllMyStorageApiClient {
    public readonly accounts: AccountsService;
    public readonly attachments: AttachmentsService;
    public readonly auth: AuthService;
    public readonly barcodes: BarcodesService;
    public readonly customFields: CustomFieldsService;
    public readonly docs: DocsService;
    public readonly icons: IconsService;
    public readonly images: ImagesService;
    public readonly import: ImportService;
    public readonly items: ItemsService;
    public readonly schemas: SchemasService;
    public readonly sentry: SentryService;
    public readonly serve: ServeService;
    public readonly settings: SettingsService;
    public readonly status: StatusService;
    public readonly user: UserService;
    public readonly request: BaseHttpRequest;
    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '0.1.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.accounts = new AccountsService(this.request);
        this.attachments = new AttachmentsService(this.request);
        this.auth = new AuthService(this.request);
        this.barcodes = new BarcodesService(this.request);
        this.customFields = new CustomFieldsService(this.request);
        this.docs = new DocsService(this.request);
        this.icons = new IconsService(this.request);
        this.images = new ImagesService(this.request);
        this.import = new ImportService(this.request);
        this.items = new ItemsService(this.request);
        this.schemas = new SchemasService(this.request);
        this.sentry = new SentryService(this.request);
        this.serve = new ServeService(this.request);
        this.settings = new SettingsService(this.request);
        this.status = new StatusService(this.request);
        this.user = new UserService(this.request);
    }
}

